import type { SkeletonProps } from "@mantine/core";
import { Skeleton, Stack } from "@mantine/core";

interface ContentWithSkeletonProps extends SkeletonProps {
  children?: React.ReactNode | undefined;
  isLoading?: boolean;
  lines?: number;
  spacing?: string;
}

function ContentWithSkeleton({
  children,
  lines = 1,
  spacing = "sm",
  isLoading = false,
  ...skeletonProps
}: ContentWithSkeletonProps) {
  if (!children || isLoading) {
    return (
      <Stack aria-label="Wird geladen" gap={spacing} role="status">
        {Array.from({ length: lines }).map((_, index) => (
          <Skeleton
            key={index}
            radius="xl"
            {...skeletonProps}
            mih={skeletonProps.mih || 20}
            miw={skeletonProps.miw || 100}
          />
        ))}
      </Stack>
    );
  }
  return <>{children}</>;
}
export { ContentWithSkeleton };
